import { IStackTokens } from '@fluentui/react';

/** Vertical gap between form fields; wrap form fields in <Stack tokens={fieldStackTokens}>. */
export const fieldStackTokens: IStackTokens = { childrenGap: 6 };

const GREEN = '#13a40e';

export const SWATCH_COLORS: Array<string> = [
  '#d80808',
  '#d65819',
  '#f38f16',
  '#eabe1e',
  GREEN,
  '#0bc5cb',
  '#0078d4',
  '#5b5eba',
  '#5d5a58',
];

/** Shown by a swatch that has no color of its own yet; must stay one of SWATCH_COLORS. */
export const DEFAULT_SWATCH_COLOR = GREEN;
